export type PortalMode = 'unified' | 'superadmin' | 'tenantadmin' | 'provider';

export const portalMode: PortalMode = 'superadmin';

export function isPortalRoleAllowed(role: string | null | undefined): boolean {
  if (portalMode === 'unified') return true;
  if (portalMode === 'superadmin') return role === 'superadmin';
  if (portalMode === 'tenantadmin') return role === 'tenantadmin' || role === 'support';
  return role === 'provideradmin' || role === 'providerstaff';
}
